import { List, Panel, Root, Tab } from "./Tabs";

export const Tabs = { Root, List, Tab, Panel };
export { useTabsItems } from "./use-tabs-items";
export { useTabsState } from "./use-tabs-state";
